import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

import moment from "moment/moment";
import styles from "./AmountField.module.sass";
import TextInput from "../../../../../components/TextInput";
import product from "../../../../../i11/Product";
import { useUser } from "../../../../../context";

const AmountField = ({ local, setLocal }) => {
	const { locale } = useUser();
	const [select, setSelect] = useState("USD");
	const [hbarPrice, setHbarPrice] = useState(0);
	const nowDate = moment().format("YYYY-MM-DD HH:mm");
	useEffect(() => {
		if (local.multiPrices && local.multiPrices.length > 0) {
			setSelect(
				local.multiPrices.length === 1
					? local.multiPrices[0].currency
					: "USD & HBAR"
			);
		}
		axios
			.get("https://api.coingecko.com/api/v3/coins/hedera-hashgraph", {
				params: {
					localization: false,
					tickers: false,
					community_data: false,
					developer_data: false,
					sparkline: false,
				},
			})
			.then((response) => {
				setHbarPrice(response.data.market_data?.current_price.usd || 0);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [usdValue, hbarValue] = useMemo(() => {
		if (local.multiPrices && local.multiPrices.length > 0) {
			const findUSD =
				local.multiPrices?.find((e) => e.currency === "USD")?.price ||
				"";
			const findHbar =
				local.multiPrices?.find((e) => e.currency === "HBAR")?.price ||
				"";

			console.log(findHbar);

			return [findUSD, findHbar];
		}
		return ["", ""];
	}, [local]);

	const fieldRender = () => {
		switch (select) {
			case "USD":
				return (
					<TextInput
						defaultValue={usdValue}
						label={product[locale].amount}
						type="number"
						min="0"
						required
						currency={"$"}
						onChangeInput={(pr) => {
							const multiPrices = [
								{
									price: pr,
									currency: "USD",
								},
							];
							setLocal((p) => {
								return {
									...p,
									multiPrices,
								};
							});
						}}
					/>
				);
			case "HBAR":
				return (
					<>
						<TextInput
							defaultValue={hbarValue}
							label={product[locale].hbar}
							type="number"
							min="0"
							required
							currency={"ℏ"}
							onChangeInput={(pr) => {
								setLocal((p) => {
									const multiPrices = [
										{
											price: pr,
											currency: "HBAR",
										},
									];
									return {
										...p,
										multiPrices,
									};
								});
							}}
						/>
						<p className={styles.reminder}>
							{product[locale].hbarReminder +
								`' ${nowDate}' is USD≈$${hbarPrice}`}
						</p>
					</>
				);
			case "USD & HBAR":
				return (
					<div>
						<TextInput
							label={product[locale].amount}
							defaultValue={usdValue}
							type="number"
							min="0"
							required
							currency={"$"}
							onChangeInput={(pr) => {
								const item = {
									price: pr,
									currency: "USD",
								};
								setLocal((p) => {
									if (p.multiPrices) {
										p.multiPrices[0] = item;
									} else {
										p.multiPrices = [item];
									}
									return {
										...p,
										multiPrices: p.multiPrices,
									};
								});
							}}
						/>
						<TextInput
							label={product[locale].hbar}
							defaultValue={hbarValue}
							type="number"
							min="0"
							required
							currency={"ℏ"}
							onChangeInput={(pr) => {
								const item = {
									price: pr,
									currency: "HBAR",
								};
								setLocal((p) => {
									if (p.multiPrices) {
										p.multiPrices[1] = item;
									} else {
										p.multiPrices = [{}, item];
									}
									return {
										...p,
										multiPrices: p.multiPrices,
									};
								});
							}}
						/>
						<p className={styles.reminder}>
							{product[locale].hbarReminder +
								`' ${nowDate}' is USD≈$${hbarPrice}`}
						</p>
					</div>
				);
			default:
				return <div />;
		}
	};

	return (
		<div>
			<div className={styles.border}>
				<div
					style={{
						display: "flex",
						marginBottom: "5px",
					}}
				>
					{["USD", "HBAR", "USD & HBAR"].map((e) => (
						<div
							style={{
								display: "flex",
								gap: "10px",
								marginRight: "20px",
							}}
							key={e}
						>
							<input
								className={styles.inputRadio}
								type="radio"
								onChange={() => setSelect(e)}
								checked={select === e}
							/>
							<p>{e}</p>
						</div>
					))}
				</div>

				{fieldRender()}
			</div>
		</div>
	);
};

export default AmountField;
